import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const delegationRouteGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.hasActiveDelegation) {
    return true;
  }

  const targetRoute = (state.url ?? '').split('?')[0];
  if (auth.activeDelegation?.supportMode === 'admin_preview') {
    const path = (targetRoute || '/dashboard').replace(/\/$/, '') || '/dashboard';
    if (path === '/dashboard' || path.startsWith('/dashboard/')) {
      return true;
    }
    return router.parseUrl('/dashboard');
  }
  if (auth.canAccessDelegatedRoute(targetRoute)) {
    return true;
  }

  return router.parseUrl(auth.delegationHomeRoute);
};

